import { AttributeReadModel } from "@Alternatives/Attributes/Domain/readmodels";
import { convertToDate } from "@common/Common";

export class AttributeUtils
{
    public static groupAndSort(attributes: AttributeReadModel[] = []): Record<string, AttributeReadModel[]>
    {
        // First, sort by Section and then by Name
        const sorted = attributes.sort((a, b) =>
        {
            if (a.Section === b.Section)
            {
                return a.Name.localeCompare(b.Name);
            }
            return a.Section.localeCompare(b.Section);
        });

        // Then, group by Section
        return sorted.reduce((acc, attribute) =>
        {
            if (!acc[attribute.Section])
            {
                acc[attribute.Section] = [];
            }
            acc[attribute.Section].push(attribute);
            return acc;
        }, {} as Record<string, AttributeReadModel[]>);
    }

    public static getGridFieldType(attribute: AttributeReadModel): string
    {
        if (attribute.IsMultivalue === true)
        {
            return "string";
        }

        if (attribute.IsList === true && attribute.IsNumeric === false)
        {
            return "string";
        }

        if (attribute.IsNumeric === true)
        {
            return "number";
        }

        if (attribute.IsDate === true)
        {
            return "date";
        }

        return "string";
    }

    public static convertUnknownValue(attribute: AttributeReadModel, value: unknown): string | number | Date | null
    {
        if (value == null) return null;

        if (attribute.IsNumeric)
        {
            if (typeof value !== 'number') 
            {
                return null;
            }

            return value;
        }

        if (attribute.IsString)
        {
            return String(value);
        }

        if (attribute.IsDate)
        {
            return convertToDate(value);
        }

        return null;
    }
}

